import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	border-radius: var(--radius-xs);
	gap: var(--gap-x4);

	a {
		all: revert;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-x3);
`;
